import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  dialogClose: {
    marginLeft: 'auto',
    padding: theme.spacing(3),
    paddingTop: 19,
  },
  links: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(4),
  },
  link: {
    fontWeight: 700,
    marginRight: 14,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  message: {
    margin: [theme.spacing(3), 0],
    textAlign: 'center',
    '& b': {
      color: 'inherit',
    },
  },
  paper: {
    [theme.breakpoints.up('mobile')]: {
      minWidth: 500,
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/EmailConfirmation/useStyles.js